
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ModulesEnum,
  ActionIdEnum,
  IFuncToRun
} from "@/services/data-service/action-queue-service";
import { ColorsService } from "@/services/colors-services";

@Component({})
export default class ActionsList extends Vue {
  showActions = false;
  get offLineStatus() {
    return this.$dataService.getters.isOffline();
  }
  get funcToRun() {
    return this.$dataService.getters.FuncQueue.funcToRun();
  }

  get isNotEmpty() {
    return this.$dataService.getters.FuncQueue.isNotEmpty();
  }

  get actionsCount() {
    return this.$dataService.getters.FuncQueue.count();
  }

  get userIsLogged() {
    return this.$dataService.getters.Auth.isUserLogged();
  }

  get offline() {
    return this.$dataService.getters.isOffline();
  }

  get actionColors() {
    return ColorsService.actionColors;
  }

  get moduleColors() {
    return ColorsService.moduleColors;
  }

  private timeout: number | undefined;
  @Prop({
    default: false,
    type: Boolean
  })
  notificationRunAllDialog!: boolean;

  @Watch("funcToRun")
  onFuncToRunChange(v: IFuncToRun) {
    this.showActions = true;
    window.clearTimeout(this.timeout);
    this.timeout = undefined;
    this.timeout = window.setTimeout(
      () => (this.timeout != undefined ? (this.showActions = false) : undefined),
      1000
    );
  }

  async created() {
    if (this.$dataService.getters.isOfflineSupport())
      await this.$dataService.actions.FuncQueue.initialize();
  }

  async undoAction() {
    window.clearTimeout(this.timeout);
    this.timeout = undefined;
    return this.$dataService.actions.FuncQueue.undo();
  }

  async runAll() {
    let action = undefined;
    do {
      action = await this.$dataService.actions.FuncQueue.run();
    } while (action != undefined);
  }

  getActionName(actionId: ActionIdEnum) {
    return ActionIdEnum[actionId];
  }

  getModuleName(moduleId: ModulesEnum) {
    return ModulesEnum[moduleId];
  }
}
